module.exports = __webpack_public_path__ + "static/img/manual-43.6ea5bed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-43.png
// module id = tzZk
// module chunks = 4